<template>
	<div class="row px-6 pb-8">
		<AppCard class="card" alpha inset no-header>
			<template v-slot:body>
				<AppList class="list" ref="list" :items="settingItems">
					<template v-slot:input-text="{item}">
						<div class="row centered space-between pt-10 pb-10">
							<p class="list-item-title">{{ item.title }}</p>
							<AppTextInput class="text-input" @changed-text="changeName" :placeholder="item.title" :value="list.title" />
						</div>
					</template>
					<template v-slot:min-prods="{item}">
						<div class="row list-item-dropdown-slot">
							<p class="list-item-title">{{ item.label }}</p>
							<AppNumberInput class="number-input" :value="list.select_min" ref="min-input" @changed-value="changeMin" :min="minInputMin" :max="minInputMax" />
						</div>
					</template>
					<template v-slot:max-prods="{item}">
						<div class="row list-item-dropdown-slot">
							<p class="list-item-title">{{ item.label }}</p>
							<AppNumberInput class="number-input" :value="list.select_max" ref="max-input" @changed-value="changeMax" :min="maxInputMin" />
						</div>
					</template>
				</AppList>
			</template>
		</AppCard>
	</div>
</template>

<script>
import AppList from "@/shared/components/AppList.vue";
import AppTextInput from "@/shared/components/AppTextInput.vue";
import AppCard from "@/shared/components/AppCard.vue";
import AppNumberInput from "@/shared/components/AppNumberInput.vue";

import {useLanguageStore} from "@/shared/stores";
import {useMenuStore} from "@/console-new/stores";

export default {
	setup() {
		let languageStore = useLanguageStore();
		let menuStore = useMenuStore();
		return {getString: languageStore.getString, menuStore};
	},
	name: "CompositeEditorOptions",
	components: {AppList, AppTextInput, AppNumberInput, AppCard},
	props: {
		categoryTempId: {
			type: String,
			required: true
		},
		itemTempId: {
			type: String,
			required: true
		},
		listTempId: {
			type: String,
			required: true
		},
	},
	computed: {
		menuItem() {
			return this.menuStore.modItemFromTempIds(this.categoryTempId, this.itemTempId);
		},
		list() {
			return this.menuItem.lists[this.listTempId];
		},
		minInputMin() {
			return this.list.select_min ? 1 : 0;
		},
		maxInputMin() {
			return this.list.select_max ? (this.list.select_min || 1) : 0;
		},
		minInputMax() {
			return this.list.select_max ? this.list.select_max : null;
		},
		settingItems() {
			return [
				{
					title: this.getString('list_name'),
					customSlot: "input-text",
				},
				{
					dropdownSlot: 'min-prods',
					title: this.getString('mandatory'),
					label: this.getString('min_products'),
					switch: true,
					active: this.list.select_min > 0,
					callback: this.switchMin
				},
				{
					dropdownSlot: 'max-prods',
					title: this.getString('products_limit'),
					label: this.getString('max_products'),
					switch: true,
					active: this.list.select_max > 0,
					callback: this.switchMax
				},
				{
					title: this.getString('products_multi_selection'),
					switch: true,
					active: this.list.select_multi,
					callback: this.switchSelectMulti,
				},
			]
		},
	},
	methods: {
		changeName(value) {
			if(value) {
				this.list.name = value;
				this.list.title = value;
			}
		},
		switchSelectMulti(value) {
			this.list.select_multi = value;
		},
		switchMin(value) {
			if(value) {
				this.list.select_min = 1;
			} else {
				this.list.select_min = 0;
			}
		},
		switchMax(value) {
			if(value) {
				this.list.select_max = this.list.select_min + 1;
			} else {
				this.list.select_max = 0;
			}
		},
		changeMin(value) {
			this.list.select_min = Number(value);
		},
		changeMax(value) {
			this.list.select_max = Number(value);
		},
	}

}
</script>

<style scoped lang="scss">
.list:deep(.list-item .list-item-header) {
	padding: 10px 0;
}

.list:deep(.list-item .dropdown-content) {
	margin-top: 0;
	background-color: $alpha_1;
}
.list:deep(.list-item:first-of-type:before),
.list:deep(.list-item:last-of-type:after) {
	display: none;
}
.card:deep(.card-body) {
	padding: 0 12px;
}
.list-item-dropdown-slot {
	@include centered;
	justify-content: space-between;
}
.text-input {
	margin-left: auto;

	@media (max-width: 560px) {
		max-width: 200px;
	}
	@media (max-width: 480px) {
		max-width: 180px;
	}
	@media (max-width: 420px) {
		max-width: 150px;
	}
	@media (max-width: 350px) {
		margin-top: 6px;
		max-width: 100%;
		width: 100%;
	}
}
.list-item-title {
	max-width: calc(100% - 105px);
	font-size: 16px;

	@media (max-width: 560px) {
		font-size: 14px;
	}
	@media (max-width: 400px) {
		font-size: 12px;
	}
	@media (max-width: 350px) {
		max-width: 100%;
		width: 100%;
	}
}

@media (max-width: 350px) {
	.list-item-dropdown-slot {
		flex-wrap: wrap;

		.number-input {
			margin-top: 6px;
			margin-left: auto;
		}
	}
}
</style>